export const OLD_CLI_WARNING_CUTOFF = 1612166400000; // Feb 1 2021 00:00:00 PST
export const PANEL_GEN_INFO_NUM_PANELS_THRESHOLD = 500; // preventative banner for panel gen awareness
